const layout = () => import("../../external/layout.vue");
const registerTerm = () => import("./registerTerm.vue");

const registerTermRoutes = {
  component: layout,
  children: [
    {
      path: "/registerTerm",
      name: "registerTerm",
      component: registerTerm,
    },
  ],
};

export default registerTermRoutes;